import { render, staticRenderFns } from "./ss-article-list.vue?vue&type=template&id=fcaa98a6&scoped=true&"
import script from "./ss-article-list.vue?vue&type=script&lang=js&"
export * from "./ss-article-list.vue?vue&type=script&lang=js&"
import style0 from "./ss-article-list.vue?vue&type=style&index=0&id=fcaa98a6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaa98a6",
  null
  
)

export default component.exports